module.exports = __webpack_public_path__ + "img/standard-test-icon-1.91f78ea3.svg";